__turbopack_export_value__({
  "body-logo-18": "servicesCarousel-module-scss-module__AZClbq__body-logo-18",
  "body-text-12": "servicesCarousel-module-scss-module__AZClbq__body-text-12",
  "body-text-14": "servicesCarousel-module-scss-module__AZClbq__body-text-14",
  "body-text-16": "servicesCarousel-module-scss-module__AZClbq__body-text-16",
  "body-text-18": "servicesCarousel-module-scss-module__AZClbq__body-text-18",
  "body-text-20": "servicesCarousel-module-scss-module__AZClbq__body-text-20",
  "body-text-24": "servicesCarousel-module-scss-module__AZClbq__body-text-24",
  "body-text-24-2": "servicesCarousel-module-scss-module__AZClbq__body-text-24-2",
  "body-text-heading-2": "servicesCarousel-module-scss-module__AZClbq__body-text-heading-2",
  "body-text-heading-3": "servicesCarousel-module-scss-module__AZClbq__body-text-heading-3",
  "body-text-medium-14": "servicesCarousel-module-scss-module__AZClbq__body-text-medium-14",
  "body-text-medium-16": "servicesCarousel-module-scss-module__AZClbq__body-text-medium-16",
  "body-text-medium-18": "servicesCarousel-module-scss-module__AZClbq__body-text-medium-18",
  "body-text-medium2-18": "servicesCarousel-module-scss-module__AZClbq__body-text-medium2-18",
  "body-text2-14": "servicesCarousel-module-scss-module__AZClbq__body-text2-14",
  "body-text2-16": "servicesCarousel-module-scss-module__AZClbq__body-text2-16",
  "button-primary-text": "servicesCarousel-module-scss-module__AZClbq__button-primary-text",
  "button-text": "servicesCarousel-module-scss-module__AZClbq__button-text",
  "button2-text": "servicesCarousel-module-scss-module__AZClbq__button2-text",
  "card-shadow": "servicesCarousel-module-scss-module__AZClbq__card-shadow",
  "effect-menu": "servicesCarousel-module-scss-module__AZClbq__effect-menu",
  "header-1": "servicesCarousel-module-scss-module__AZClbq__header-1",
  "main-container": "servicesCarousel-module-scss-module__AZClbq__main-container",
  "main-footer-container": "servicesCarousel-module-scss-module__AZClbq__main-footer-container",
  "main-header-container": "servicesCarousel-module-scss-module__AZClbq__main-header-container",
  "popularServices__head": "servicesCarousel-module-scss-module__AZClbq__popularServices__head",
  "popularServices__navArrows": "servicesCarousel-module-scss-module__AZClbq__popularServices__navArrows",
  "popularServices__title": "servicesCarousel-module-scss-module__AZClbq__popularServices__title",
  "sliderContainer": "servicesCarousel-module-scss-module__AZClbq__sliderContainer",
  "sliderContainer__card": "servicesCarousel-module-scss-module__AZClbq__sliderContainer__card",
  "txt-12-bold": "servicesCarousel-module-scss-module__AZClbq__txt-12-bold",
  "txt-14-bold": "servicesCarousel-module-scss-module__AZClbq__txt-14-bold",
  "txt-14-bold-caps": "servicesCarousel-module-scss-module__AZClbq__txt-14-bold-caps",
  "txt-14-med": "servicesCarousel-module-scss-module__AZClbq__txt-14-med",
  "txt-16-bold": "servicesCarousel-module-scss-module__AZClbq__txt-16-bold",
  "txt-16-med": "servicesCarousel-module-scss-module__AZClbq__txt-16-med",
  "txt-18-bold": "servicesCarousel-module-scss-module__AZClbq__txt-18-bold",
  "txt-18-medium": "servicesCarousel-module-scss-module__AZClbq__txt-18-medium",
  "txt-18-medium-24": "servicesCarousel-module-scss-module__AZClbq__txt-18-medium-24",
  "txt-24-semi": "servicesCarousel-module-scss-module__AZClbq__txt-24-semi",
});
